// Which of the two feedback sections is available, and which is waiting on
// the one above it. Modelled on taraFeedbackGating.js, at two stages instead
// of three: mastery_scoring is a real backend stage but never a client-facing
// one (it runs inline, with no button), so it never appears here.
//
// Locked-ness is derived on every render and never stored, same reason as
// TARA's: storing it produces the bug where re-running the reasoning trace
// leaves the examiner report unlocked against output that no longer exists.

export const LNAT_FEEDBACK_STAGES = ['reasoning_trace', 'examiner_report'];

export const LNAT_STAGE_TITLES = {
  reasoning_trace: 'Reasoning Trace',
  examiner_report: 'Examiner Report',
};

function phaseFor(entry) {
  if (!entry) return 'idle';
  if (entry.phase === 'running' || entry.status === 'in_progress') return 'running';
  if (entry.status === 'failed' || entry.status === 'invalid_output') return 'error';
  if (entry.phase === 'error') return 'error';
  if (entry.status === 'succeeded' && entry.data) return 'ready';
  if (entry.phase === 'ready' && entry.data) return 'ready';
  return 'idle';
}

export function lnatFeedbackGating(stages = {}) {
  const out = {};
  let blocked = false;
  let blockedBy = null;

  LNAT_FEEDBACK_STAGES.forEach((stage, index) => {
    const entry = stages[stage];
    const phase = phaseFor(entry);

    if (blocked) {
      out[stage] = {
        phase: 'locked',
        lockReason: `Available once ${LNAT_STAGE_TITLES[blockedBy]} has run.`,
      };
      return;
    }

    out[stage] = { phase, lockReason: null };

    const previous = LNAT_FEEDBACK_STAGES[index];
    if (phase !== 'ready') {
      blocked = true;
      blockedBy = previous;
    }
  });

  return out;
}

export function lnatNextRunnableStage(stages = {}) {
  const gating = lnatFeedbackGating(stages);
  return LNAT_FEEDBACK_STAGES.find((s) => gating[s].phase === 'idle') || null;
}
